import React, { useState, useCallback, useReducer } from 'react';
import './PropertySummaryMPIComponent.scss';
import {
  SingleBed,
  BathtubOutlined,
  PowerInputOutlined,
  HomeWorkOutlined,
} from '@material-ui/icons';
import { useTranslation } from 'react-i18next';
import { Spinner, DialogComponent } from '../../../../../../Components';
import { StaticLookupsIds } from '../../../../../../assets/json/StaticLookupsIds';
import { PropertieMPIGaugeChartComponent } from '../../../PropertiesUtilities/Dialogs/PropertieGaugeChartComponent/PropertieMPIGaugeChartComponent';
import { FormatPriceShortenedNotationHelper } from '../../../../../../Helper'; 

export const PropertySummaryMPIComponent = ({
  summaryData,
  parentTranslationPath,
  isLoading,
}) => {
  const translationPath = '';
  const { t } = useTranslation(parentTranslationPath);
  const formatNumber = new Intl.NumberFormat('eu-US', {
    maximumFractionDigits: 0,
  });

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [selectedUnits, setSelectedUnits] = useState([]);
  const [activeUnit, setActiveUnit] = useState(null);
  const [defaultState, setDefaultState] = useState({
    minPrice: null,
    maxPrice: null,
    medianPrice: null,
    medianPricePerSqft: null,
    psiPrice: null,
    noMPIDataFoundForTheUnit: null,
  });
  const reducer = (state, action) => ({ ...state, [action.id]: action.value });
  const [state, setState] = useReducer(reducer, {
    ...defaultState,
  });


  const handleUnitsClick = useCallback((item) => {
    const units = item.unitReferences || [];
    setSelectedUnits(units);
    setIsDialogOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setIsDialogOpen(false);
    setSelectedUnits([]);
    setActiveUnit(null);
  }, []);

  const handleUnitSelect = useCallback((unit) => {
    setActiveUnit({
      id: unit.unitId,
      builtup_area_sqft: parseFloat(unit.builtup_area_sqft),
      medianPricePerSqft: summaryData.find(item => item.unitReferences.some(ref => ref.unitRefNo === unit.unitRefNo))?.medianPricePerSqft || 0,
      marketComparison: null,
    });
  }, [summaryData]);

  const getOperationTypeId = (operationType) => {
    switch (operationType.toLowerCase()) {
      case 'sales':
        return StaticLookupsIds.Sales;
      case 'rent':
        return StaticLookupsIds.Rent;
      case 'saleandrent':
        return StaticLookupsIds.SaleAndRent;
      default:
        return StaticLookupsIds.Sales;
    }
  };
  const getStyleDependingOnOnNumberOfUnitMatching = () => {
    if (
      summaryData.some(
        (a) =>
          a.numberOfUnitMatching === "0" ||
          !a.numberOfUnitMatching ||
          a.numberOfUnitMatching === ""
      )
    )
      return "11rem";
    return "11rem";
  };


  const formatWithThousandSeparator = (value) => {
    if (!value || isNaN(value)) return value;
    return Number(value).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  };


  return (
    <div className="custom-table">
      <Spinner isActive={isLoading} isAbsolute />
      {summaryData?.map((item) => (
        <div className="table-item">
          <div className="left-side-table">
            {" "}
            <div className="unit-type">
              <span>{t(`${translationPath}unit-type`)}</span>
              <h5>{item?.unitType || ""} </h5>
            </div>
            <div className="num-ads">
              <span>{t(`${translationPath}OperationType`)}</span>
              <h5>{item?.operationType || ""}</h5>
            </div>
            <div className="num-ads">
              <span>{t(`${translationPath}number-of-ads`)}</span>
              <h5>{item?.totalRows || ""}</h5>
            </div>
            <div
              className="d-flex-v-center-h-center numberOfUnitMatchingText clickable "
              onClick={() =>
                item?.numberOfUnitMatching && item?.numberOfUnitMatching !== "0"
                  ? handleUnitsClick(item)
                  : undefined
              }
              style={{ width: getStyleDependingOnOnNumberOfUnitMatching() }}
            >
              <span className="numberOfUnitMatchingText d-flex-center  aligncenter">
                {t(`${translationPath}matching-crm-units`)}
              </span>

              <span className="d-flex-center px-4">
                {item?.numberOfUnitMatching &&
                item?.numberOfUnitMatching !== "0" ? (
                  <div>
                    {formatWithThousandSeparator(item.numberOfUnitMatching)}
                  </div>
                ) : (
                  <h6>No matching CRM units available</h6>
                )}
              </span>
            </div>
            <div
              className=" details-container"
              style={{
                height: "44px",
                "line-height": "20px",
                "font-size": "12px",
              }}
            >
              <div className="sub-details-container">
                <SingleBed fontSize="small" />
                <h5>{item?.bedrooms || ""}</h5>
                <h5>{t(`${translationPath}bedrooms`)}</h5>
              </div>
              <div className="sub-details-container">
                <PowerInputOutlined fontSize="small" />
                <h5>{t(`${translationPath}MedianSize`)}</h5>
                <h5>
                  {item?.medianSize
                    ? Number(item.medianSize).toLocaleString(undefined, {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 2,
                      })
                    : ""}
                </h5>
              </div>
            </div>
          </div>

          <div className="right-side-table">
            <div className="price-info">
              <span>{t(`${translationPath}median-price-per-sqft`)}</span>
              <h5>
                {(item?.medianPricePerSqft &&
                  FormatPriceShortenedNotationHelper(
                    item?.medianPricePerSqft
                  )) ||
                  0}
              </h5>
              <p>AED/sqft</p>
            </div>
            <div className="price-info">
              <span>{t(`${translationPath}median-price`)}</span>
              <h5>
                {(item?.medianPrice &&
                  FormatPriceShortenedNotationHelper(item.medianPrice)) ||
                  0}
              </h5>
              <p>AED</p>
            </div>
          </div>
        </div>
      ))}
      <DialogComponent
        isOpen={isDialogOpen}
        onCloseClicked={handleClose}
        onSaveClicked={handleClose}
        titleText={t(
          `${translationPath}matching-crm-units`,
          "matching-crm-unit"
        )}
        maxWidth="lg"
        dialogContent={
          <div
            className="dialog-content"
            style={{ display: "flex", height: "500px" }}
          >
            <div
              style={{
                width: "50%",
                overflowY: "auto",
                padding: "16px",
                borderRight: "1px solid #ddd",
              }}
            >
              <h3>{t(`${translationPath}unit-list`)}</h3>
              {selectedUnits.length > 0 ? (
                <ul style={{ listStyle: "none", padding: 0 }}>
                  {selectedUnits.map((unit) => (
                    <li
                      key={unit.unitRefNo}
                      style={{
                        padding: "12px",
                        margin: "8px 0",
                        background:
                          activeUnit?.id === unit.unitRefNo
                            ? "#e0f7fa"
                            : "#f5f5f5",
                        borderRadius: "8px",
                        cursor: "pointer",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        transition: "background 0.2s",
                      }}
                      onClick={() => handleUnitSelect(unit)}
                    >
                      <div>
                        <strong>{t(`${translationPath}unit-ref`)}:</strong>{" "}
                        {unit.unitRefNo}
                        <br />
                        <strong>
                          {t(`${translationPath}builtup-area`)}:
                        </strong>{" "}
                        {unit.builtup_area_sqft} sqft
                      </div>
                      <span style={{ color: "#007bff", fontWeight: "bold" }}>
                        {t(`${translationPath}view-details`)}
                      </span>
                    </li>
                  ))}
                </ul>
              ) : (
                <div>
                  <p
                    style={{
                      marginTop: "16px",
                      fontSize: "16px",
                      color: "#555",
                    }}
                  >
                    {t(`${translationPath}no-units-available`)}
                  </p>
                </div>
              )}
            </div>
            <div
              style={{
                width: "50%",
                padding: "16px",
                display: "flex",

                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              {activeUnit ? (
                <div style={{ maxWidth: "15rem" }}>
                  <PropertieMPIGaugeChartComponent
                    marketComparison={activeUnit?.marketComparison || null}
                    unitId={activeUnit.id}
                    operationType={getOperationTypeId(
                      summaryData[0]?.operationType || "Sales"
                    )}
                    parentTranslationPath="UnitsView"
                    translationPath=""
                    activeData={activeUnit}
                    viewArt={true}
                  />
                </div>
              ) : (
                <div>
                  <svg
                    fill="#397bc0"
                    height="136px"
                    width="136px"
                    version="1.1"
                    id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 512.004 512.004"
                    xmlSpace="preserve"
                    stroke="#397bc0"
                  >
                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                    <g
                      id="SVGRepo_tracerCarrier"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      stroke="#CCCCCC"
                      strokeWidth="2.048016"
                    ></g>
                    <g id="SVGRepo_iconCarrier">
                      <g>
                        <g>
                          <g>
                            <path d="M469.336,341.337c-4.719,0-8.533,3.823-8.533,8.533v145.067h-59.733c-4.719,0-8.533,3.823-8.533,8.533 s3.814,8.533,8.533,8.533h68.267c4.719,0,8.533-3.823,8.533-8.533v-153.6C477.869,345.16,474.054,341.337,469.336,341.337z"></path>
                            <path d="M443.735,418.137V349.87c0-4.71-3.814-8.533-8.533-8.533h-51.2c-4.719,0-8.533,3.823-8.533,8.533v68.267 c0,4.71,3.814,8.533,8.533,8.533h51.2C439.921,426.67,443.735,422.847,443.735,418.137z M426.669,409.603h-34.133v-51.2h34.133 V409.603z"></path>
                            <path d="M332.802,145.07c4.719,0,8.533-3.823,8.533-8.533V93.87c0-4.71-3.814-8.533-8.533-8.533h-256 c-4.719,0-8.533,3.823-8.533,8.533v298.667c0,4.71,3.814,8.533,8.533,8.533s8.533-3.823,8.533-8.533V375.47h8.533 c4.719,0,8.533-3.823,8.533-8.533s-3.814-8.533-8.533-8.533h-8.533v-51.2h34.133v34.133c0,4.71,3.814,8.533,8.533,8.533 s8.533-3.823,8.533-8.533v-34.133h34.133c4.719,0,8.533-3.823,8.533-8.533c4.719,0,8.533-3.823,8.533-8.533v-51.2h34.133 c0,4.71,3.814,8.533,8.533,8.533s8.533-3.823,8.533-8.533c4.719,0,8.533-3.823,8.533-8.533s-3.814-8.533-8.533-8.533v-51.2 h34.133v17.067c0,4.71,3.814,8.533,8.533,8.533c4.719,0,8.533-3.823,8.533-8.533V170.67h17.067c4.719,0,8. personally c4.719,0,8.533-3.823,8.533-8.533 c0-4.71-3.814-8.533-8.533-8.533h-17.067v-51.2h34.133v34.133C324.269,141.247,328.083,145.07,332.802,145.07z M119.469,290.137 H85.335v-51.2h34.133V290.137z M119.469,221.87H85.335v-51.2h34.133V221.87z M119.469,153.603H85.335v-51.2h34.133V153.603z M170.669,290.137h-34.133v-51.2h34.133V290.137z M170.669,221.87h-34.133v-51.2h34.133V221.87z M170.669,153.603h-34.133v-51.2 h34.133V153.603z M221.869,221.87h-34.133v-51.2h34.133V221.87z M221.869,153.603h-34.133v-51.2h34.133V153.603z M273.069,153.603h-34.133v-51.2h34.133V153.603z"></path>
                            <path d="M42.669,435.203c4.719,0,8.533-3.823,8.533-8.533V68.27h59.733c4.719,0,8.533-3.823,8.533-8.533v-25.6h59.733 c4.719,0,8.533-3.823,8.533-8.533V17.07h34.133v8.533c0,4.71,3.814,8.533,8.533,8.533h59.733v17.067H145.069 c-4.719,0-8.533,3.823-8.533,8.533s3.814,8.533,8.533,8.533h213.333v34.133c0,4.71,3.814,8.533,8.533,8.533 s8.533-3.823,8.533-8.533V59.737c0-4.71-3.814-8.533-8.533-8.533h-59.733v-25.6c0-4.71-3.814-8.533-8.533-8.533h-59.733V8.537 c0-4.71-3.814-8.533-8.533-8.533h-51.2c-4.719,0-8.533,3.823-8.533,8.533v8.533h-59.733c-4.719,0-8.533,3.823-8.533,8.533v25.6 H42.669c-4.719,0-8.533,3.823-8.533,8.533V426.67C34.135,431.38,37.95,435.203,42.669,435.203z"></path>
                            <path d="M503.469,187.737h-59.733v-8.533c0-4.71-3.814-8.533-8.533-8.533h-34.133c-4.719,0-8.533,3.823-8.533,8.533v17.067 c0,4.71,3.814,8.533,8.533,8.533c4.719,0,8.533-3.823,8.533-8.533v-8.533h17.067v8.533c0,4.71,3.814,8.533,8.533,8.533h59.733 v115.934l-130.5-130.5c-3.337-3.336-8.73-3.336-12.066,0c-3.337,3.337-3.337,8.73,0,12.066L497.436,347.37 c1.63,1.63,3.814,2.5,6.033,2.5c1.101,0,2.21-0.213,3.268-0.649c3.192-1.323,5.265-4.437,5.265-7.885V196.27 C512.002,191.559,508.188,187.737,503.469,187.737z"></path>
                            <path d="M366.935,477.87h-85.333c-4.719,0-8.533,3.823-8.533,8.533v8.533h-85.333V375.47c0-4.71-3.814-8.533-8.533-8.533 s-8.533,3.823-8.533,8.533v128c0,4.71,3.814,8.533,8.533,8.533h102.4c4.719,0,8.533-3.823,8.533-8.533v-8.533h68.267v8.533 c0,4.71,3.814,8.533,8.533,8.533s8.533-3.823,8.533-8.533v-17.067C375.469,481.693,371.654,477.87,366.935,477.87z"></path>
                            <path d="M509.502,2.503c-3.336-3.336-8.73-3.336-12.066,0L2.502,497.437c-3.336,3.337-3.336,8.73,0,12.066 c1.664,1.664,3.849,2.5,6.033,2.5c2.185,0,4.369-0.836,6.033-2.5L509.502,14.57C512.838,11.233,512.838,5.84,509.502,2.503z"></path>
                            <path d="M349.869,460.803c4.719,0,8.533-3.823,8.533-8.533v-102.4c0-4.71-3.814-8.533-8.533-8.533h-51.2 c-4.719,0-8.533,3.823-8.533,8.533v102.4c0,4.71,3.814,8.533,8.533,8.533s8.533-3.823,8.533-8.533v-93.867h34.133v34.133h-8.533 c-4.719,0-8.533,3.823-8.533,8.533s3.814,8.533,8.533,8.533h8.533v42.667C341.336,456.98,345.15,460.803,349.869,460.803z"></path>
                            <path d="M213.336,341.337c-4.719,0-8.533,3.823-8.533,8.533v68.267c0,4.71,3.814,8.533,8.533,8.533h51.2 c4.719,0,8.533-3.823,8.533-8.533V349.87c0-4.71-3.814-8.533-8.533-8.533H213.336z M256.002,409.603h-34.133v-51.2h34.133 V409.603z"></path>
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                  <p
                    style={{
                      marginTop: "16px",
                      fontSize: "16px",
                      color: "#555",
                    }}
                  >
                    {t(`${translationPath}select-unit-to-view-chart`)}
                  </p>
                </div>
              )}
            </div>
          </div>
        }
        parentTranslationPath={parentTranslationPath}
        translationPath={translationPath}
        saveClasses="btns theme-solid bg-primary w-100 mx-2 mb-2"
        onCancelClicked={handleClose}
      />
    </div>
  );
};
